import moment, { Moment } from 'moment';

export const dateToMoment = (date?: Date | string | null | undefined) => {
  return date ? moment(date) : null;
};

export const momentToDate = (date?: Moment | null) => {
  return date ? date.toDate() : null;
};
